import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from '@react-pdf/renderer';
import { usePDFContext } from './pdf.context';
const stylesRecipient = StyleSheet.create({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        fontWeight: 400,
        color: '#545454',
        fontSize: 10
    },
    label: {
        fontWeight: 500,
        color: '#8A8A8A'
    },
    name: {
        fontSize: 12,
        color: '#000000'
    },
    email: {
        fontSize: 10,
        color: '#000000'
    },
    address: {
        fontSize: 9,
        color: '#545454'
    }
});
export const RecipientDetails = ({ label, name, email, address }) => {
    const { Text, View } = usePDFContext();
    return (_jsxs(View, { style: stylesRecipient.container, children: [_jsx(Text, { style: stylesRecipient.label, children: label }), _jsx(Text, { style: stylesRecipient.name, children: name }), address && (_jsx(Text, { style: stylesRecipient.address, children: address })), _jsx(Text, { style: stylesRecipient.email, children: email })] }));
};
